import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "requisites" }
const _hoisted_2 = { class: "requisites__container" }
const _hoisted_3 = { class: "requisites__block" }
const _hoisted_4 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_5 = { class: "requisites__content" }
const _hoisted_6 = {
  key: 0,
  class: "requisites__block"
}
const _hoisted_7 = { class: "requisites__label requisites__label--start text-capitalize-first" }
const _hoisted_8 = { class: "requisites__content" }
const _hoisted_9 = { class: "requisites__controls" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    onOnClose: _ctx.hide,
    title: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("labels.name")), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormInputWrapper, {
                field: "name",
                form: "group"
              }, {
                default: _withCtx((parentProps) => [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    type: "text",
                    id: "name"
                  }, null, 2), [
                    [_vModelText, _ctx.form.name]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.user.isTrafficGroupOnReqsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("labels.traffic_groups")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FormInputWrapper, {
                    field: "trafficGroupIds",
                    form: "group"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_TrafficGroupMultiselect, {
                        class: _normalizeClass(parentProps.class),
                        multiple: true,
                        modelValue: _ctx.form.trafficGroups,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.trafficGroups) = $event))
                      }, null, 8, ["class", "modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn",
            type: "button",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.save,
            class: "btn btn--accept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('button.save')), 1)
            ]),
            _: 1
          }, 8, ["on-click"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}